import { AE } from '@agora/ae-client'
import DA from '@agora/data-analysis'
import { I18n, InitI18n } from '@web/react-common'
import { usePrevious } from 'ahooks'
import { Spin } from 'antd'
import { isEmpty } from 'lodash'
import React from 'react'

import { useGetViewerQuery } from '@/generated/graphql'
import { ga } from '@/utils/ga'

const loadingDom = document.querySelector('.tale-loading')
if (loadingDom) {
  loadingDom.remove()
}

export const Login: React.FC = ({ children }) => {
  const url = window.location.pathname + window.location.search
  const userAgent = window.navigator.userAgent
  const { data, loading, error } = useGetViewerQuery({
    variables: {
      isInitialLoad: true,
      url,
      userAgent,
    },
  })

  const previous = usePrevious(data)

  React.useEffect(() => {
    if (error) {
      window.location.href = `/api/oauth/login?redirect_uri=${encodeURIComponent(window.location.href)}`
    }
  }, [error])

  React.useLayoutEffect(() => {
    if (!previous && data) {
      // ga 埋点
      ga('config', 'G-G8XCWY689H', {
        user_id: data.viewer.email,
        user_email: data.viewer.email,
      })

      // 数据应用埋点工具
      DA.init({
        client_token: '9478-9479-9480',
        biz_name: 'taleWebapp',
        user_id: data.viewer.email,
        debug: !window.location.hostname.includes('t.agoralab.co'),
        disabledRequestEvent: true,
      })

      // 全局卡片
      AE.init({
        appId: 'tale',
        plugins: [
          {
            name: 'enterprise-user-card',
            options: {
              tale: {
                viewer: {
                  email: data.viewer.email,
                },
              },
            },
          },
        ],
      })
    }
  }, [data, previous])

  if (loading || !data || isEmpty(data.viewer) || error) {
    return (
      <div
        style={{
          height: '100vh',
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <Spin
          size='large'
          style={{
            display: 'flex',
            flex: 1,
            alignItems: 'center',
          }}
        />
        <div style={{ marginTop: 'auto', padding: '32px 0' }}>
          无法登录？请确认浏览器为最新版本。或联系 @wangzhaoren
        </div>
      </div>
    )
  }

  return (
    <InitI18n
      language={data.viewer.language}
      getLocale={(s: string) =>
        s.startsWith('zh') ? import('@/i18n/zh/translation.json') : import('@/i18n/en/translation.json')
      }
    >
      <I18n>{children}</I18n>
    </InitI18n>
  )
}
